/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rosy_Pure_Ox_RoamInputs */

const en_rosy_pure_ox_roam = /** @type {(inputs: Rosy_Pure_Ox_RoamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Column mapping`)
};

const de_rosy_pure_ox_roam = /** @type {(inputs: Rosy_Pure_Ox_RoamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spalten zuweisen`)
};

/**
* | output |
* | --- |
* | "Column mapping" |
*
* @param {Rosy_Pure_Ox_RoamInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const rosy_pure_ox_roam = /** @type {((inputs?: Rosy_Pure_Ox_RoamInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rosy_Pure_Ox_RoamInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_rosy_pure_ox_roam(inputs)
	return de_rosy_pure_ox_roam(inputs)
});